import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserResponse } from 'algorilla-shared-libs';
import { FieldMapping } from 'src/app/dashboard/model/field-mapping';
import { ImportComponent } from 'src/app/import-export/import.component';
import { ImportType } from 'src/app/import-export/model/import-type.enum';
import { ManagementService } from 'src/app/services/management.service';
import { QueryManagerService } from 'src/app/services/query-manager.service';
import { ErrorMessage } from 'src/app/shared/error-message';
import { NotificationsService } from 'bowman-angular2-notifications';
import { BowmanCacheService } from 'bowman-cache';
import { ActionResult, CrudActionType, HelperFunctions, TableFilterPipe } from 'bowman-commons';
import { forkJoin, Observable, Observer, Subscription } from 'rxjs';
import { TypeMappingService } from 'src/services/type-mapping.service';
import { NodeStats } from '../model/node-stats';
import { TimePeriod } from '../model/time-period';
import { TypeMapping } from '../model/type-mapping';
import { TypeMappingEstimation } from '../model/type-mapping-estimation';
import { TypeMappingOverview } from '../model/type-mapping-overview';

const CACHE_EXPIRE_MS = 30000;

@Component({
     selector: 'app-type-mapping',
     templateUrl: './type-mapping.component.html',
     styleUrls: ['./type-mapping.component.scss'],

     providers: [TypeMappingService, QueryManagerService, TableFilterPipe],
     encapsulation: ViewEncapsulation.None,
     changeDetection: ChangeDetectionStrategy.OnPush,

})
export class TypeMappingComponent implements OnInit {
     get countObjectKeys() { return HelperFunctions.countObjectKeys }
     get getAvaibleSpace() { return TypeMappingComponent.getAvaibleSpace }

     @Input() public name: string;
     public tmpTypeMapping: TypeMapping = new TypeMapping();
     public typeMappings: Array<TypeMapping> = null;
     public typeMappingOverview: Array<TypeMappingOverview> = null;

     public indicesCloseableList = {};
     public errorMessage: ErrorMessage = new ErrorMessage();
     public action: CrudActionType;
     public crudActionTypes = CrudActionType;
     public busy: Subscription;
     public refreshBusy: Subscription;
     public searchText: string;
     public exportList: Array<TypeMapping> = [];
     public importTypes = ImportType;
     public tmpField: FieldMapping = new FieldMapping();
     public tmpFieldMappings: Array<FieldMapping> = [];
     public fieldMappings: Array<FieldMapping> = null;
     public selectedTimePeriod: TimePeriod = new TimePeriod("Days", 60 * 60 * 24);
     public availableTimePeriods: Array<TimePeriod> = [new TimePeriod("Seconds", 1), new TimePeriod("Minutes", 60), new TimePeriod("Hours", 60 * 60), new TimePeriod("Days", 60 * 60 * 24), new TimePeriod("Weeks", 60 * 60 * 24 * 7)];
     public nodeStats: Array<NodeStats> = [];

     public typeMappingEventAverageSize = {};
     public typeMappingEstimatedStoreSize = {};
     public typeMappingEstimatedRetentionPeriod = {};
     public typeMappingEstimation: Map<string, TypeMappingEstimation> = new Map();
     public fieldTypes: Array<{ name: string, type: string }> = [
          { name: "String", type: "text" },
          { name: "Keyword", type: "text" },
          { name: "Long", type: "long" },
          { name: "Float", type: "float" },
          { name: "Date", type: "date" },
          { name: "IP Address", type: "ip" }];
     public disabledForm: boolean = false;


     selectedDateFormat: { format: any; } = { format: null };
     selectedFieldType: { name: string, type: string } = { name: null, type: null };
     dateFormats: Array<string> = [
          'epoch_millis',
          'epoch_second',
          'yyyyMMdd\'T\'HHmmss.SSSZ',
          'yyyyMMdd\'T\'HHmmssZ',
          'HHmmss.SSSZ',
          'HHmmssZ',
          'yyyy-MM-dd HH:mm:ss',
          'yyyy-MM-dd',
          'dd/MM/yyyy HH:mm:ss',
          'dd/MM/yyyy'
     ];

     // Type overview
     public chartOptions: any = {};
     public selectedTimestampField: string = null;
     public user: UserResponse;
     get handleExportList() { return ImportComponent.handleExportList }
     get fillExportList() { return ImportComponent.fillExportList }
     get exportObjects() { return ImportComponent.exportObjects }
     public openImportModal(name: ImportType) {
          const modalRef = this._modalService.open(ImportComponent, { centered: true, scrollable: true, size: 'lg' });
          modalRef.componentInstance.type = name;
          modalRef.result.then(() => {
               this._bowmanCacheService.flushServiceCacheByMethod('listTypeMappings');
               this.busy = TypeMappingComponent.getTypeMappings(this._typeMappingService, this._bowmanCacheService).subscribe(tm => {
                    this.typeMappings = tm;
                    this._cdr.detectChanges();
               }, err => {
                    this.errorMessage = new ErrorMessage('Unable to list type mappings.', err);
                    this._cdr.detectChanges();
               })
          }, () => {
               this._bowmanCacheService.flushServiceCacheByMethod('listTypeMappings');

               this.busy = TypeMappingComponent.getTypeMappings(this._typeMappingService, this._bowmanCacheService).subscribe(tm => {
                    this.typeMappings = tm;
                    this._cdr.detectChanges();
               }, err => {
                    this.errorMessage = new ErrorMessage('Unable to list type mappings.', err);
                    this._cdr.detectChanges();
               })
          })
     }
     constructor(
          private _typeMappingService: TypeMappingService,
          private _queryService: QueryManagerService,
          private _bowmanCacheService: BowmanCacheService,
          private _notificationsService: NotificationsService,
          private _modalService: NgbModal,
          public _managementService: ManagementService,
          private _cdr: ChangeDetectorRef,
          public tableFilterPipe: TableFilterPipe,
          private _activatedRoute: ActivatedRoute
     ) { }


     private getFieldsMappingArray(): Observable<Array<FieldMapping>> {
          return Observable.create((observer: Observer<Array<TypeMapping>>) => {
               this.busy = this._bowmanCacheService.callService(this._queryService, 'getFieldsMapping', CACHE_EXPIRE_MS, null).subscribe(res => {
                    if (res.status == 'OK') {
                         let map: { [fieldName: string]: FieldMapping[] } = {}
                         res.result.map(fm => {
                              if (!map[fm.name]) { map[fm.name] = [] }
                              map[fm.name].push(fm);
                         })
                         observer.next(HelperFunctions.removeDuplicates(res.result, 'name'));
                    } else {
                         this.errorMessage = new ErrorMessage('Unable to list field mappings.', res.message);
                         observer.next(null);
                    }
               }, err => {
                    this.errorMessage = new ErrorMessage('Unable to list field mappings.', err);
               });
          });
     }
     public static getTypeMappings(typeMappingService: TypeMappingService, BowmanCacheService: BowmanCacheService): Observable<Array<TypeMapping>> {
          return Observable.create((observer: Observer<Array<TypeMapping>>) => {
               BowmanCacheService.callService(typeMappingService, 'listTypeMappings', CACHE_EXPIRE_MS, null).subscribe(res => {
                    if (res.status == 'OK') {
                         if (res.result != null) {
                              res.result = HelperFunctions.sortByField(res.result, 'name');
                         }
                         observer.next(res.result);
                         observer.complete()
                    } else {
                         observer.error(res.message);
                         observer.next(null);
                         observer.complete();
                    }
               }, err => {
                    observer.error(err);
                    observer.next(null);
                    observer.complete();
               });
          });
     }
     public static dynamicFieldMappingList(typeMappingService: TypeMappingService, BowmanCacheService: BowmanCacheService): Observable<{ [name: string]: Array<FieldMapping> }> {
          return Observable.create((observer: Observer<{ [name: string]: Array<FieldMapping> }>) => {
               BowmanCacheService.callService(typeMappingService, 'dynamicFieldMappingList', CACHE_EXPIRE_MS, null).subscribe(res => {
                    if (res.status == 'OK') {
                         if (res.result != null) {
                              for (let typeName in res.result) {
                                   res.result[typeName] = HelperFunctions.sortByField(res.result[typeName], 'name');
                              }
                         }
                         observer.next(res.result);
                         observer.complete()
                    } else {
                         observer.error(res.message);
                         observer.next(null);
                         observer.complete();
                    }
               }, err => {
                    observer.error(err);
                    observer.next(null);
                    observer.complete();
               });
          });
     }


     public static getTypeMappingOverview(typeMappingService: TypeMappingService, BowmanCacheService: BowmanCacheService): Observable<Array<TypeMappingOverview>> {
          return Observable.create((observer: Observer<Array<TypeMappingOverview>>) => {
               BowmanCacheService.callService(typeMappingService, 'getTypeMappingOverview', CACHE_EXPIRE_MS, null).subscribe((res) => {
                    if (res.status == 'OK') {

                         observer.next(res.result);
                         observer.complete();
                    } else {
                         observer.error("Unable to get Type Mappings Overview: " + res.message);
                         observer.complete();
                    }
               }, err => {
                    observer.error("Unable to get Type Mappings Overview: " + err);
                    observer.complete();
               });
          });
     }

     public static getAvaibleSpace(nodeStats: Array<NodeStats>): number {
          let result: number = 0;
          if (nodeStats && nodeStats != null && nodeStats.length > 0) {
               nodeStats.forEach(ns => {
                    result += ns.fsAvailable;
               })
          }
          return result;
     }

     private getTypeMappingOverview(): Observable<Array<TypeMappingOverview>> {
          return Observable.create((observer: Observer<Array<TypeMappingOverview>>) => {
               let calls: Array<Observable<any>> = [];
               calls.push(TypeMappingComponent.getTypeMappingOverview(this._typeMappingService, this._bowmanCacheService));
               calls.push(this._bowmanCacheService.callService(this._typeMappingService, 'getAvailableSpaceByNodes', CACHE_EXPIRE_MS, null));

               forkJoin(calls).subscribe((results: Array<any>) => {
                    let typeMappingOverview: Array<TypeMappingOverview> = results[0];
                    let nodeStats: Array<NodeStats> = results[1].result;
                    typeMappingOverview.forEach(tm => {
                         tm.indicesOverview = HelperFunctions.sortByField(tm.indicesOverview, 'status', 'desc');
                         let openIndex: number = 0;
                         tm.indicesOverview.forEach(index => {
                              if (index.status == 'open') {
                                   openIndex++;
                              }
                         });
                         this.indicesCloseableList[tm.name] = openIndex;
                    });
                    this.nodeStats = HelperFunctions.cloneObject(nodeStats);
                    let availableSpaceInBytes: number = TypeMappingComponent.getAvaibleSpace(this.nodeStats);
                    typeMappingOverview.filter(tm => tm.timestampField == "timestamp").forEach(tm => {
                         this.typeMappings.filter(typeMapping => typeMapping.name == tm.name).map(typeMapping => {
                              let tmEstimation: TypeMappingEstimation = new TypeMappingEstimation(tm, availableSpaceInBytes, (typeMapping.rollMaxNumRecords * typeMapping.rollKeepSize));
                              this.typeMappingEstimation.set(tm.name, tmEstimation);
                         });
                    });
                    this._cdr.detectChanges();
                    observer.next(typeMappingOverview);
                    observer.complete();
               });
          });
     }

     public showDetails(typeMapping: TypeMapping) {
          this.action = CrudActionType.DETAILS;
          this.selectedTimestampField = null;
          this.tmpTypeMapping = HelperFunctions.cloneObject(typeMapping);
          let typeData: Array<TypeMappingOverview> = [];

          // this.prepareChartData(typeData);

     }

     public showTypeOverview(timestampField: string) {
          this.selectedTimestampField = timestampField;
          if (this.typeMappingOverview && this.typeMappingOverview.length > 0) {
               this.typeMappingOverview.forEach(tmo => {
                    if (tmo.name == this.tmpTypeMapping.name && tmo.timestampField == timestampField) {
                         this.prepareChartData([tmo]);
                    }
               });
               this._cdr.detectChanges();
          }
     }

     public static getFieldsMapping(BowmanCacheService: BowmanCacheService, queryService: QueryManagerService): Observable<{ [name: string]: FieldMapping }> {
          let fieldMappings: { [name: string]: FieldMapping } = {};
          return Observable.create((observer: Observer<{ [name: string]: FieldMapping }>) => {
               BowmanCacheService.callService(queryService, 'getFieldsMapping', CACHE_EXPIRE_MS, null).subscribe(res => {
                    const response: ActionResult<Array<FieldMapping>> = (res as ActionResult<Array<FieldMapping>>);
                    if (response.status == 'OK') {
                         response.result.forEach(field => {
                              fieldMappings[field.name] = field;
                         });
                         observer.next(fieldMappings);
                         observer.complete();
                    }
                    else {
                         observer.error(res.message);
                         observer.complete();
                    }
               }, err => {
                    observer.error(err);
                    observer.complete();
               });
          });
     }

     public handleTypeChange(type: any, fm: FieldMapping) {
          if (type.name === 'Keyword') {
               fm.hasKeyword = true;
          }
     }
     public createTypeMapping() {
          this.action = CrudActionType.CREATE;
          this.tmpField = new FieldMapping();
          this.tmpFieldMappings = [];
          this.tmpTypeMapping = new TypeMapping();
          this.errorMessage.reset();
     }
     public editTypeMapping(name: string) {
          this.action = CrudActionType.EDIT;
          this.errorMessage.reset();
          this.tmpField = new FieldMapping();
          this.tmpFieldMappings = [];
          this.tmpTypeMapping = new TypeMapping();
          this.typeMappings.forEach(tm => {
               if (tm.name == name) {
                    this.tmpTypeMapping = HelperFunctions.cloneObject(tm);
               }
          });

     }
     public addFieldMapping(fm: FieldMapping): void {
          if (this.tmpTypeMapping.fields) {
               this.tmpFieldMappings.push(fm);
               this.tmpField = new FieldMapping();
          }
     }

     public removeField(fm: FieldMapping): void {
          if (this.tmpFieldMappings) {
               if (this.tmpFieldMappings.indexOf(fm) >= 0) {
                    this.tmpFieldMappings.splice(this.tmpFieldMappings.indexOf(fm), 1);
               }
          }
     }

     public saveTypeMapping(tm: TypeMapping) {
          let isValid: boolean = true;
          if (!tm.name || tm.name === null) {
               isValid = false;
               this.errorMessage = new ErrorMessage("Validation error", "Type mapping name cannot be empty.");
          }
          if (this.tmpFieldMappings && this.tmpFieldMappings.length > 0) {
               this.tmpFieldMappings.forEach(tfm => {
                    tm.fields.push(tfm);
               })
          }

          if (isValid) {
               switch (this.action) {
                    case CrudActionType.EDIT:
                         this.busy = this._typeMappingService.updateTypeMapping(tm).subscribe(res => {
                              if (res.status == 'OK') {
                                   this._notificationsService.success("Type mapping updated");
                                   TypeMappingComponent.getTypeMappings(this._typeMappingService, this._bowmanCacheService).subscribe(res => {
                                        this.typeMappings = res;
                                        this.action = CrudActionType.LIST;
                                        this.tmpTypeMapping = new TypeMapping();
                                        this.errorMessage.reset();
                                        this.getTypeMappingOverview().subscribe();
                                        this._cdr.detectChanges();

                                   }, err => {
                                        this.errorMessage = new ErrorMessage('Unable to list type mappings.', err);
                                   });
                              } else {
                                   this.errorMessage = new ErrorMessage("Cannot update type mapping", res.message + ' ' + res.result);
                              }
                         }, error => {
                              this.errorMessage = new ErrorMessage("Cannot update type mapping", error);
                         });
                         break;
                    case CrudActionType.CREATE:
                         this.busy = this._typeMappingService.createTypeMapping(tm).subscribe(res => {
                              if (res.status == 'OK') {
                                   this._notificationsService.success("Type mapping created");
                                   TypeMappingComponent.getTypeMappings(this._typeMappingService, this._bowmanCacheService).subscribe(res => {
                                        this.typeMappings = res;
                                        this.action = CrudActionType.LIST;
                                        this.tmpTypeMapping = new TypeMapping();
                                        this.errorMessage.reset();
                                        this.getTypeMappingOverview().subscribe();
                                        this._cdr.detectChanges();
                                   }, err => {
                                        this.errorMessage = new ErrorMessage('Unable to list type mappings.', err);
                                   });
                              } else {
                                   this.errorMessage = new ErrorMessage("Cannot create type mapping", res.message + ' ' + res.result);
                              }
                         }, error => {
                              this.errorMessage = new ErrorMessage("Cannot create type mapping", error);
                         })
                         break;
               }
          }
     }
     public deleteObjects(list: Array<TypeMapping>) {
          let calls: Array<Observable<any>> = [];
          list.forEach(tm => {
               calls.push(this._typeMappingService.deleteTypeMapping(tm.name));
          });
          this.busy = forkJoin(calls).subscribe((results: Array<any>) => {
               this._notificationsService.success(list.length + ' Type Mappings successfully deleted');
               TypeMappingComponent.getTypeMappings(this._typeMappingService, this._bowmanCacheService).subscribe(res => {
                    this.action = CrudActionType.LIST;
                    this.tmpTypeMapping = new TypeMapping();
                    this.errorMessage.reset();
                    this.getTypeMappingOverview().subscribe(tmOverview => {
                         this.typeMappingOverview = tmOverview;
                    });
                    this.typeMappings = res;
                    this._cdr.detectChanges();
               }, err => {
                    this.errorMessage = new ErrorMessage('Unable to list type mappings.', err);
               });
               this.exportList = [];
          }, err => {
               this._notificationsService.success('Errors occurred while deleting Type Mappings', err);
               TypeMappingComponent.getTypeMappings(this._typeMappingService, this._bowmanCacheService).subscribe(res => {
                    this.action = CrudActionType.LIST;
                    this.typeMappings = res;
                    this.tmpTypeMapping = new TypeMapping();
                    this.errorMessage.reset();
                    this.getTypeMappingOverview().subscribe(tmOverview => {
                         this.typeMappingOverview = tmOverview;
                    });
                    this._cdr.detectChanges();
               }, err => {
                    this.errorMessage = new ErrorMessage('Unable to list type mappings.', err);
               });
               this.exportList = [];
          });
     }

     public deleteTypeMapping(name: string) {
          this.busy = this._typeMappingService.deleteTypeMapping(name).subscribe(res => {
               TypeMappingComponent.getTypeMappings(this._typeMappingService, this._bowmanCacheService).subscribe(res => {
                    this._notificationsService.success("Type mapping " + name + " successfully deleted.");
                    this.typeMappings = res;
                    this.action = CrudActionType.LIST;
                    this.tmpTypeMapping = new TypeMapping();
                    this.errorMessage.reset();
                    this.getTypeMappingOverview().subscribe(tmOverview => {
                         this.typeMappingOverview = tmOverview;
                    })
               }, err => {
                    this.errorMessage = new ErrorMessage('Unable to list type mappings.', err);
               });
          }, err => {
               this.errorMessage = new ErrorMessage("Cannot delete type mapping", err);
          });
     }

     public closeAllIndices(typeName: string) {
          this.busy = this._typeMappingService.closeAllIndexes(typeName).subscribe(res => {
               if (res.status == 'OK') {
                    this.refreshIndexData().subscribe(r => {
                         this._notificationsService.success(typeName + "indices closed successfully.", res.result + ' indices closed');
                    })
               } else {
                    this._notificationsService.error("Error closing indices: ", res.message);
               }
          }, err => {
               this._notificationsService.error("Error closing indices: ", err);
          })
     }
     public openAllIndices(typeName: string) {
          this.busy = this._typeMappingService.openAllIndexes(typeName).subscribe(res => {
               if (res.status == 'OK') {
                    this.refreshIndexData().subscribe(r => {
                         this._notificationsService.success(typeName + "indices opened successfully.", res.result + ' indices opened');
                    })
               } else {
                    this._notificationsService.error("Error opening indices: ", res.message);
               }
          }, err => {
               this._notificationsService.error("Error opening indices: ", err);
          })
     }
     public openIndex(indexName: string) {
          this.busy = this._typeMappingService.openIndex(indexName).subscribe(res => {
               if (res.status == 'OK') {
                    this.refreshIndexData().subscribe(r => {
                         this._notificationsService.success(indexName + "index reopened successfully.");
                    })
               } else {
                    this._notificationsService.error("Error opening index: ", res.message);
               }
          }, err => {
               this._notificationsService.error("Error opening index: ", err);
          })
     }

     public handleIngestion(typeMapping: TypeMapping): void {
          this._cdr.detach();
          typeMapping.injestionActive = !typeMapping.injestionActive;
          this.busy = this._typeMappingService.updateTypeMapping(typeMapping).subscribe(res => {
               if (res.status == 'OK') {
                    this._notificationsService.success("Type mapping updated");
                    TypeMappingComponent.getTypeMappings(this._typeMappingService, this._bowmanCacheService).subscribe(res => {
                         this.typeMappings = res;
                         this.action = CrudActionType.LIST;
                         this.tmpTypeMapping = new TypeMapping();
                         this.errorMessage.reset();
                         this._cdr.reattach();
                    }, err => {
                         this.errorMessage = new ErrorMessage("Unable to list type mappings", res.message);
                         this._cdr.reattach();
                    });
               } else {
                    this.errorMessage = new ErrorMessage("Cannot update type mapping", res.message);
                    this._cdr.reattach();
               }
          }, error => {
               this.errorMessage = new ErrorMessage("Cannot update type mapping", error);
               this._cdr.reattach();
          });
     }
     ngOnInit() {
          if (this._bowmanCacheService.has('algorilla_user')) {
               this._bowmanCacheService.get('algorilla_user').subscribe(user => {
                    this.user = user;
               });
               this.action = CrudActionType.LIST;
               this.busy = TypeMappingComponent.getTypeMappings(this._typeMappingService, this._bowmanCacheService).subscribe(tm => {
                    this.typeMappings = tm;
                    this.getTypeMappingOverview().subscribe(tmOverview => {
                         this.typeMappingOverview = tmOverview;
                         this.handleActivatedRoute();

                    });
                    this._cdr.detectChanges();
               }, err => {
                    this.errorMessage = new ErrorMessage('Unable to list type mappings.', err);
                    this._cdr.detectChanges();
               });
               this.getFieldsMappingArray().subscribe(fm => {
                    this.fieldMappings = fm;
               });
          } else {
               this.user = null;
               this.errorMessage = new ErrorMessage("Cannot get user information");
          }
     }
     private initChartOptions(): any {
          return {
               credits: {
                    enabled: false
               },
               exporting: {
                    enabled: false
               },
               title: {
                    text: ''
               },
               colors: ["rgba(243, 211, 74, 1)"],
               chart: {
                    type: 'columnrange',
                    inverted: true
               },

               xAxis: {
                    categories: [],
                    labels: {
                         rotate: '-45'
                    },
                    gridLineColor: "#adb5bd",
                    gridLineWidth: 1,
                    gridLineDashStyle: "dot",
                    startOnTick: true,
                    endOnTick: true
               },
               yAxis: {
                    type: 'datetime',
                    style: {
                         'font-family': 'Lato,Sans'
                    },
                    gridLineWidth: 0
               },
               legend: {
                    enabled: false
               },
               tooltip: {

               },
               plotOptions: {
                    series: {
                         animation: true,
                         shadow: true,
                         borderColor: "#eea243",
                         style: {
                              'font-family': 'Lato,Sans'
                         }
                    }
               },
               series: []

          };
     }
     private prepareChartData(typeOverviewData: Array<TypeMappingOverview>) {
          this.chartOptions = this.initChartOptions();
          typeOverviewData.forEach(typeMappingOverview => {
               let tmpData: Array<Array<number>> = [];
               typeMappingOverview.indicesOverview.forEach(index => {
                    if (index.minTime > 0 && index.maxTime > 0) {
                         this.chartOptions.xAxis.categories.push(index.name + '-' + index.eventsCount);
                         tmpData.push([index.minTime, index.maxTime]);
                    }
               });

               this.chartOptions.series.push({ 'name': typeMappingOverview.timestampField, 'data': tmpData })
               this.chartOptions.chart.height = 200 + (this.chartOptions.xAxis.categories.length * 30);

               this.chartOptions.tooltip.formatter = function () {
                    if (this.x) {
                         return '<strong>' + this.x.split('-')[0] + '</strong><br /><br /><strong>Events:</strong> ' + Number(this.x.split('-')[1]).toLocaleString() + '<br/><strong>From:</strong> ' + window['Highcharts'].dateFormat('%d-%m-%y %H:%M:%S', this.point.low) + '<br/><strong>To:</strong> ' + window['Highcharts'].dateFormat('%d-%m-%y %H:%M:%S', this.point.high);
                    }
               }
               this.chartOptions.xAxis.labels = {
                    formatter: function () {
                         if (this.value) {
                              return this.value.split('-')[0];
                         } else {
                              return 'missing';
                         }
                    }
               }


          });
     }
     public refreshData(): void {
          this.refreshIndexData().subscribe();
          this._cdr.detectChanges();
     }

     private refreshIndexData(): Observable<any> {
          return Observable.create((observer: Observer<any>) => {
               this.refreshBusy = this._managementService.refreshIndexStats().subscribe(res => {
                    if (res.status == 'OK') {
                         this.getTypeMappingOverview().subscribe(tmo => {
                              this.typeMappingOverview = HelperFunctions.clone(tmo);
                              this.showTypeOverview(this.selectedTimestampField);
                         });
                    } else {
                         this._notificationsService.error('Cannot refresh index stats', res.message);
                    }
               }, err => {
                    this._notificationsService.error('Cannot refresh index stats', err);
               }).add(() => {
                    this._cdr.detectChanges();
               })
          });
     }

     private handleActivatedRoute(): void {
          // Questa funzione viene attivata quando si torna su quest componente da un altro.
          this._activatedRoute.url.subscribe(url => {
               this.busy = TypeMappingComponent.getTypeMappings(this._typeMappingService, this._bowmanCacheService).subscribe(tm => {
                    this.typeMappings = tm;
                    this.getTypeMappingOverview().subscribe(tmOverview => {
                         this.typeMappingOverview = tmOverview;
                    })
               }, err => {
                    this.errorMessage = new ErrorMessage('Unable to list type mappings.', err);
               });
               this.getFieldsMappingArray().subscribe(fm => {
                    this.fieldMappings = fm;
               })
          });
     }
}

